<template>
  <div>
    <div class="card mb-3">
      <div class="card-header border-bottom pb-3">
        <span class="card-subtitle">
          <i class="fa-duotone fa-circle-info fa-md text-danger"></i> Urgent
          Filing Requirement
        </span>
        <div
          class="d-flex align-items-center"
          v-if="cartStore.cartData?.initialFormData"
        >
          <h4 class="card-header-title">
            {{ cartStore.cartData.initialFormData.corporation_name }}
          </h4>
        </div>
        <small class="text-muted fs-5">
          {{ filingTypeDisplay }}
        </small>
        <div id="card-badges">
          <small>
            <span
              class="badge"
              :class="{
                'bg-soft-danger text-danger':
                  cartStore.cartData.initialFormData.status === 'I',
                'bg-soft-success text-success':
                  cartStore.cartData.initialFormData.status === 'A'
              }"
            >
              {{
                cartStore.getChoiceDisplay(
                  'florida_corporation_status',
                  cartStore.cartData.initialFormData.status
                )
              }}
            </span>
            <span class="ms-1 badge bg-soft-danger text-danger">
              Risk of Noncompliance
            </span>
          </small>
        </div>
      </div>
      <div class="card-body business-filing-card">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useCartStore } from '../../stores/cartStore'

// Define component props
const props = defineProps({
  id: {
    type: String,
    default: 'business-card'
  }
})

// Initialize the cart store
const cartStore = useCartStore()

// Compute the display value for the filing type
const filingTypeDisplay = computed(() => {
  return cartStore.getChoiceDisplay(
    'filing_type',
    cartStore.cartData.initialFormData.filing_type
  )
})
</script>
